
























import {
  Vue,
  Component,
  Watch,
} from "@/shared/vuepack";

import AccountAlert from "@/shared/components/accountAlert/AccountAlert.vue";
import Button from "@/shared/components/ui/Button.vue";
import { useAccountAlertStore } from "@/shared/store/accountAlert";
import { useUserStore } from "@/shared/store/user";

@Component({
  components: {
    AccountAlert,
    Button
  }
})
export default class AccountAlertPanel extends Vue {

  accountAlertStore = useAccountAlertStore();
  userStore = useUserStore();

  mounted (): void {
    if (this.userStore.loggedIn) {
      this.accountAlertStore.loadAccountAlerts();
    }
  }

  @Watch("userStore.loggedIn")
  onLoggedIn (newValue, oldValue): void {
    if (newValue) {
      this.accountAlertStore.loadAccountAlerts();
    }
  }

  handleClick (): void {
    if (this.accountAlertStore.unreadAccountAlertsCount) {
      this.accountAlertStore.setAccountAlertsRead();
    }
  }
}
